import { useSelector } from 'react-redux';
import { useState, useEffect } from "react";
import { Grid } from '@mui/material';
import { gridSpacing } from '../../store/constant';
import AddFileLimitForm from '../components/AddFileLimitForm';
import axios from "../../components/axios";
import { useNavigate } from 'react-router-dom';



const AddFileLimitPage = () => {
    const customization = useSelector((state) => state.customization);
    const navigate = useNavigate();
    const [triggerFunctions, setTriggerFunctions] = useState([]);

    useEffect(() => {
        const getTriggerFunctions = async () => {
            try {
                const response = await axios.post("/peloton/v1/automation/limit-triggers", null, { withCredentials: true});
                if (response.data.message === "success"){
                    setTriggerFunctions(response.data.trigger_list);
                }
            } catch (error) {
                if (error.response.status !== null){
                    if (error.response.status === 401){
                        alert(error.response.data.message);
                        navigate("/");
                    }else{
                        console.log('error.response.status: ', error.response.status)
                        console.log('error.response.message: ', error.response.data.message)
                    }
                }else{
                    console.log(error);
                }
            }
        };
        getTriggerFunctions();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Grid container spacing={gridSpacing} alignItems="center" sx={{ marginTop: "40px"}}>
            <Grid item xs={12} >
                    {customization.login && (<AddFileLimitForm triggerFunctions={triggerFunctions}/>)}
            </Grid>
        </Grid>
    );
};

export default AddFileLimitPage;